import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { SharedModule } from '../shared.module';

import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';

import { HeaderComponent } from "./header/header.component";
import { SearchComponent } from "./search/search.component";
import { QuickViewComponent } from './quick-view/quick-view.component';
import { SideNavComponent } from "./side-nav/side-nav.component";
import { FooterComponent } from "./footer/footer.component";

import { SideNavDirective } from "../directives/side-nav.directive";
import { ThemeConstantService } from '../services/theme-constant.service';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzTableModule } from 'ng-zorro-antd/table';
import { ResourceComponent } from 'src/app/resource/resource.component';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NewResourceComponent } from 'src/app/new-resource/new-resource.component';
import { NzFormModule } from 'ng-zorro-antd/form';
import { ResourceDetailComponent } from 'src/app/resource-detail/resource-detail.component';
import { LoginComponent } from 'src/app/login/login.component';
import { AccessGroupComponent } from 'src/app/access-group/access-group.component';
import { EventComponent } from 'src/app/event/event.component';
import { KnowledgeBaseComponent } from 'src/app/knowledge-base/knowledge-base.component';
import { AcademyComponent } from 'src/app/academy/academy.component';
import { DataListingComponent } from 'src/app/data-listing/data-listing.component';
import { KnowledgeBaseListingComponent } from 'src/app/knowledge-base-listing/knowledge-base-listing.component';
import { CourseListingComponent } from 'src/app/course-listing/course-listing.component';
import { UserListingComponent } from 'src/app/user-listing/user-listing.component';
import { NzAnchorModule } from 'ng-zorro-antd/anchor';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NzSelectModule } from 'ng-zorro-antd/select';

import { MessageComponent } from 'src/app/message/message.component';
import { QuillModule } from 'ngx-quill';

import { DragDropModule } from '@angular/cdk/drag-drop'; 
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { UserPanelComponent } from 'src/app/user-panel/user-panel.component';
import { NewsletterComponent } from 'src/app/newsletter/newsletter.component';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { FormsModule } from '@angular/forms';
import { NotificationComponent } from 'src/app/notification/notification.component';

const antdModule = [
    NzAvatarModule,
    NzBadgeModule,
    NzRadioModule,
    NzDropDownModule,
    NzListModule,
    NzDrawerModule,
    NzDividerModule,
    NzSwitchModule,
    NzInputModule,
    NzButtonModule,
    NzCardModule,
    NzTableModule,
    NzAvatarModule ,
    NzPopoverModule,
    NzCheckboxModule,
    NzTagModule,
    NzFormModule,
    NzAnchorModule,
    NzPopconfirmModule,
    NzIconModule,
    NzSpinModule,
    NzToolTipModule,
    BrowserAnimationsModule,
    NzSelectModule,
    DragDropModule,
    NzInputNumberModule,
    NzModalModule,
    FormsModule,
    QuillModule.forRoot({
        modules: {
          syntax: true,
          toolbar: [['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          [ 'code-block'],
    
          [{ 'header': 1 }, { 'header': 2 }],               // custom button values
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
          [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
          [{ 'direction': 'rtl' }],                         // text direction
    
          [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    
          [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
          [{ 'font': [ 'arial','times-new-roman','calibri', 'comic-sans-ms'] }],
          [{ 'align': [] }],
    
          ['clean'],                                         // remove formatting button
    
          ['link', 'image', 'video']     ]
        }
      })
    

]

@NgModule({
    exports: [
        CommonModule,
        HeaderComponent,
        SearchComponent,
        QuickViewComponent,
        SideNavComponent,
        SideNavDirective,
        FooterComponent
    ],
    imports: [
        RouterModule,
        CommonModule,
        SharedModule,
        ...antdModule
    ],
    declarations: [
        HeaderComponent,
        SearchComponent,
        QuickViewComponent,
        SideNavComponent,
        SideNavDirective,
        FooterComponent,
        ResourceComponent,
        NewResourceComponent,
        LoginComponent,
        AccessGroupComponent,
        EventComponent,
        KnowledgeBaseComponent,
        AcademyComponent,
        DataListingComponent,
        KnowledgeBaseListingComponent,
        CourseListingComponent,
        UserListingComponent,
        MessageComponent,
        NotificationComponent,
        UserPanelComponent,
        NewsletterComponent,
    ],
    providers: [ 
        ThemeConstantService
    ]
})

export class TemplateModule { }
